import React, { useState, useMemo, forwardRef, useCallback } from 'react';
import { Form } from 'antd'
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes } from 'utils/formUtils';
import GenericMappingForm from '../GenericMappingForm';
import { uniqBy } from 'lodash';

const DependabotMappingForm = forwardRef((props, ref) => {
  const [options,setOptions] = useState(() => {
    if (props.record) {
      const { owner , repositoryName } = props.record;
      const repositoryNameArray = repositoryName.split(',');  
      return repositoryNameArray.map(value => ({id: value, name: value, otherProperties: { owner : { login: owner}}}))
    }
    return [];
  });
  const [form] = Form.useForm();
  
  const setOptionsFromPagination = (option) => {
    setOptions(prev => uniqBy([...prev,...option], 'name'));
  }

  const getExtraFieldsData = (config) => {
    const { repositoryName } = config;
    const data = options.reduce((acc,cv) =>{
      const { id, name,  otherProperties: { owner:{ login } } } = cv;
      if(repositoryName.includes(id)){
        acc.name.push(name);
        acc["owner"] = login;
      }
      return acc;
    },{name:[]})

    return ({
      repositoryName:data.name.join(),
      owner: data.owner
    });
  };

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    return { 
      repositoryName:config.repositoryName.split(','),
    };
  }, []);

  const projectChangeHandler = useCallback((value, field,selectValue) => {
    const { name } = field;
    const configurations = form.getFieldValue("configurations");
    let updatedConfiguration = [
      ...configurations
    ];
    updatedConfiguration[name] = {
      ...updatedConfiguration[name],
    }
    form.setFieldsValue({ configurations: updatedConfiguration })
  }, [form])

  const fetchRepos = useCallback((params) => {
    const { promise,cancel } =  ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, params);
    promise.then((data) => setOptionsFromPagination(data.projects))
    return { promise,cancel}
  }, [props.toolName]);

  const extraFields = useMemo(() => ([
    {
      name: 'repositoryName',
      colSpan: '16',
      type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
      label: 'Repository',
      props: {
        mode:"multiple",
        apiParams: {login_id: props.loginConfigId},
        api: fetchRepos,
        onChange: projectChangeHandler,
        autoFocus: true
      },
      rules: [{ required: true, message: 'Repository is required' }]
    }
  ]), [projectChangeHandler,props.loginConfigId, fetchRepos]);


  return (
    <GenericMappingForm
      form={form}
      ref={ref}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      {...props}
    />
  )
})

export default DependabotMappingForm;